import { CountUp, Reveal } from "./lib";
import { highlights, keyFigures, quickFacts, IMG } from "./content";
import { HighlightItem } from "./parts";
import { VIDEOS, VideoFeature } from "./Video";

export function HighlightsSection() {
  return (
    <section id="highlights" className="am-section scroll-mt-28 py-20 sm:py-28" data-testid="am-section-highlights">
      <div className="mx-auto max-w-[1320px] px-5 sm:px-8">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <p className="am-eyebrow am-accent">Introduction</p>
            <h2 className="am-title mt-3 text-5xl sm:text-6xl lg:text-7xl" data-section-heading tabIndex={-1}>2025 Highlights</h2>
          </div>
        </div>

        <ul className="mt-14 grid grid-cols-2 gap-x-6 gap-y-10 border-y border-[var(--am-line)] py-10 lg:grid-cols-6" data-testid="am-key-figures">
          {keyFigures.map((f, i) => (
            <Reveal as="li" key={f.label} delay={i * 0.05} testId={`am-key-figure-${i}`}>
              <CountUp value={f.value} className="block text-4xl font-semibold am-accent sm:text-5xl" />
              <span className="mt-2 block text-sm leading-snug">{f.label}</span>
            </Reveal>
          ))}
        </ul>

        <div className="mt-16 grid gap-10 lg:grid-cols-[1fr_340px]">
          <ul className="grid gap-x-10 gap-y-9 sm:grid-cols-2" data-testid="am-highlights-list">
            {highlights.map((h, i) => <HighlightItem key={h.lead} item={h} index={i} testId={`am-highlight-${i}`} />)}
          </ul>
          <div className="flex flex-col gap-6">
            <aside className="relative bg-[var(--am-blue)] p-7 text-white [clip-path:polygon(0_0,100%_0,100%_92%,88%_100%,0_100%)]" data-testid="am-quick-facts">
              <h3 className="text-lg font-semibold">FY 2025 Quick Facts</h3>
              <dl className="mt-4 divide-y divide-white/30">
                {quickFacts.map((q) => (
                  <div key={q.label} className="py-3">
                    <dt className="sr-only">{q.label}</dt>
                    <dd><CountUp value={q.value} className="block text-3xl font-semibold" /><span className="text-sm text-white/90">{q.label}</span></dd>
                  </div>
                ))}
              </dl>
            </aside>
            <div className="am-photo am-clip hidden aspect-[4/5] lg:block">
              <img src={IMG("p5_0.jpg")} alt="A gloved hand holding a semiconductor chip" className="h-full w-full object-cover" loading="lazy" />
            </div>
          </div>
        </div>
        <VideoFeature video={VIDEOS.highlights} testId="am-video-highlights" />
      </div>
    </section>
  );
}
